const NARRATIVE_PROFILE_FIELDS = new Set([
  'businessBio',
  'businessFaq',
  'businessHours',
  'businessServices',
  'staffBio',
]);

function comparisonText(value) {
  return String(value || '')
    .normalize('NFKC')
    .toLocaleLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, ' ')
    .trim()
    .replace(/\s+/g, ' ');
}

function phoneDigits(value) {
  const digits = String(value || '').replace(/\D/g, '');
  return digits.length === 11 && digits.startsWith('1') ? digits.slice(1) : digits;
}

export function profileSuggestionIsDuplicate(fieldKey, suggestion, currentValue) {
  if (!String(suggestion || '').trim() || !String(currentValue || '').trim()) return false;
  if (fieldKey === 'businessPhoneNumber') {
    const suggestionDigits = phoneDigits(suggestion);
    return Boolean(suggestionDigits) && suggestionDigits === phoneDigits(currentValue);
  }

  const suggestionText = comparisonText(suggestion);
  const currentText = comparisonText(currentValue);
  if (!suggestionText || !currentText) return false;
  if (suggestionText === currentText) return true;
  if (!NARRATIVE_PROFILE_FIELDS.has(fieldKey)) return false;
  return ` ${currentText} `.includes(` ${suggestionText} `);
}
